import {
  FileText, File, Folder, FolderOpen, Archive, BookOpen, Book,
  Clipboard, ClipboardList, FileCheck, FileX, FilePlus, Search,
  Shield, ShieldCheck, Clock, Calendar, AlertTriangle, CheckCircle,
  Info, Settings, Download, Upload, Link, Tag, Star, Bookmark,
  Eye, Lock, Users,
  type LucideIcon,
} from 'lucide-react'

export const DOCUMENT_TYPE_ICONS: { name: string; Icon: LucideIcon }[] = [
  { name: 'FileText', Icon: FileText },
  { name: 'File', Icon: File },
  { name: 'Folder', Icon: Folder },
  { name: 'FolderOpen', Icon: FolderOpen },
  { name: 'Archive', Icon: Archive },
  { name: 'BookOpen', Icon: BookOpen },
  { name: 'Book', Icon: Book },
  { name: 'Clipboard', Icon: Clipboard },
  { name: 'ClipboardList', Icon: ClipboardList },
  { name: 'FileCheck', Icon: FileCheck },
  { name: 'FileX', Icon: FileX },
  { name: 'FilePlus', Icon: FilePlus },
  { name: 'Search', Icon: Search },
  { name: 'Shield', Icon: Shield },
  { name: 'ShieldCheck', Icon: ShieldCheck },
  { name: 'Clock', Icon: Clock },
  { name: 'Calendar', Icon: Calendar },
  { name: 'AlertTriangle', Icon: AlertTriangle },
  { name: 'CheckCircle', Icon: CheckCircle },
  { name: 'Info', Icon: Info },
  { name: 'Settings', Icon: Settings },
  { name: 'Download', Icon: Download },
  { name: 'Upload', Icon: Upload },
  { name: 'Link', Icon: Link },
  { name: 'Tag', Icon: Tag },
  { name: 'Star', Icon: Star },
  { name: 'Bookmark', Icon: Bookmark },
  { name: 'Eye', Icon: Eye },
  { name: 'Lock', Icon: Lock },
  { name: 'Users', Icon: Users },
]

export function resolveIcon(name: string): LucideIcon {
  return DOCUMENT_TYPE_ICONS.find((i) => i.name === name)?.Icon ?? FileText
}
